<div class="gpd-full-page">
    <div class="form-style straight-bottom-radius" style="border-radius: 0px 0px 0px 0px;">
        <div class="gt-secondary-nav-tab-container">
            <div class="gt-secondary-nav-tab " i18n="@@budget" routerLink="budget"
                routerLinkActive="secondary-nav-tab-active">Budget</div>
            <div class="gt-secondary-nav-tab" i18n="@@actual" routerLink="actual"
                routerLinkActive="secondary-nav-tab-active">Plan/Actual</div>
            <div class="gt-secondary-nav-tab" i18n="@@controlling" routerLink="controlling"
                routerLinkActive="secondary-nav-tab-active">Controlling</div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
